import InstallationListFilters from './InstallationListFilters';

export default InstallationListFilters;
